<template>
	<div class="min-h-screen w-full">
		<div class="w-full border-b border-gray-200 bg-white p-6 sm:px-20">
			<!-- <div>
                <jet-application-logo class="block h-12 w-auto" />
            </div> -->

			<div class="mt-8 text-2xl">Willkommen in Bernstein Badshop!</div>

			<div class="mt-6 text-gray-500">Kurze info</div>
		</div>

		<div
			class="grid w-full grid-cols-1 bg-gray-200 bg-opacity-25 shadow-md md:grid-cols-2"
		>
			<div class="border border-gray-300 bg-slate-50 p-6">
				<div class="flex items-center">
					<svg
						fill="none"
						stroke="currentColor"
						stroke-linecap="round"
						stroke-linejoin="round"
						stroke-width="2"
						viewBox="0 0 24 24"
						class="h-8 w-8 text-gray-400"
					>
						<path
							d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253"
						></path>
					</svg>
					<div class="ml-4 text-lg font-semibold leading-7 text-gray-600">
						<a href="https://laravel.com/docs"> Dokumentation</a>
					</div>
				</div>

				<div class="ml-12">
					<div class="mt-2 text-sm text-gray-500">
						Hier werden Dokumente angezeigt.
					</div>
					<a href="https://laravel.com/docs">
						<div
							class="mt-3 flex items-center text-sm font-semibold text-indigo-700"
						>
							<div>Explore the documentation</div>

							<div class="ml-1 text-indigo-500">
								<svg viewBox="0 0 20 20" fill="currentColor" class="h-4 w-4">
									<path
										fill-rule="evenodd"
										d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z"
										clip-rule="evenodd"
									></path>
								</svg>
							</div>
						</div>
					</a>
				</div>
			</div>

			<div
				class="border border-gray-300 bg-slate-50 p-6 md:border-t-0 md:border-l"
			>
				<div class="flex items-center">
					<svg
						fill="none"
						stroke="currentColor"
						stroke-linecap="round"
						stroke-linejoin="round"
						stroke-width="2"
						viewBox="0 0 24 24"
						class="h-8 w-8 text-gray-400"
					>
						<path
							d="M3 9a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 0110.07 4h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0018.07 7H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z"
						></path>
						<path d="M15 13a3 3 0 11-6 0 3 3 0 016 0z"></path>
					</svg>
					<div class="ml-4 text-lg font-semibold leading-7 text-gray-600">
						<a href="https://bernstein.store"> Einkauf Bereich</a>
					</div>
				</div>

				<div class="ml-12">
					<ul class="px 2">
						<li class="list-inside list-disc py-1 font-semibold text-gray-800">
							<a href="/variations/index"> Variation with Stock </a>
						</li>
						<li class="list-inside list-disc py-1 font-semibold text-gray-800">
							<a href="/stocks/index"> Stock Filter </a>
						</li>
						<li class="list-inside list-disc py-1 font-semibold text-gray-800">
							<a href="/manufacturers/index"> Manufacturers </a>
						</li>
						<li class="list-inside list-disc py-1 font-semibold text-gray-800">
							<a href="/warehouses/index"> Warehosues </a>
						</li>
						<li class="list-inside list-disc py-1 font-semibold text-gray-800">
							<a href="/purchases/create"> Purchase Entry </a>
						</li>
						<li class="list-inside list-disc py-1 font-semibold text-gray-800">
							<a href="/purchases"> Purchase List</a>
						</li>
					</ul>
				</div>
			</div>

			<div class="border border-gray-300 bg-slate-50 p-6">
				<div class="flex items-center">
					<svg
						fill="none"
						stroke="currentColor"
						stroke-linecap="round"
						stroke-linejoin="round"
						stroke-width="2"
						viewBox="0 0 24 24"
						class="h-8 w-8 text-gray-400"
					>
						<path
							d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
						></path>
					</svg>
					<div class="ml-4 text-lg font-semibold leading-7 text-gray-600">
						<a href="https://tailwindcss.com/"> Verkauf </a>
					</div>
				</div>

				<div class="ml-12">
					<ul class="px 2">
						<li class="list-inside list-disc py-1 font-semibold text-gray-800">
							<a href="/orders/index"> Orders </a>
						</li>
						<li class="list-inside list-disc py-1 font-semibold text-gray-800">
							<a href="/orderitems/index">Order Items</a>
						</li>
						<!-- <li class="list-disc list-inside py-1 text-gray-800 font-semibold"><a href="/manufacturers/index"> Manufacturers </a> </li> -->
						<!-- <li class="list-disc list-inside py-1 text-gray-800 font-semibold"><a href="/warehouses/index"> Warehosues </a> </li>                          -->
					</ul>
				</div>
			</div>
			<!-- here  -->
			<!-- Service Bereich  -->
			<div
				v-if="isFromService"
				class="border border-gray-300 bg-slate-50 p-6 md:border-l"
			>
				<div class="flex items-center">
					<svg
						fill="none"
						stroke="currentColor"
						stroke-linecap="round"
						stroke-linejoin="round"
						stroke-width="2"
						viewBox="0 0 24 24"
						class="h-8 w-8 text-gray-400"
					>
						<path
							d="M3 9a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 0110.07 4h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0018.07 7H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z"
						></path>
						<path d="M15 13a3 3 0 11-6 0 3 3 0 016 0z"></path>
					</svg>
					<div class="ml-4 text-lg font-semibold leading-7 text-gray-600">
						Service Bereich
					</div>
				</div>

				<div class="m-2 flex flex-col">
					<h1 class="p-2 text-lg font-bold text-gray-900">Wichtig links</h1>
					<ul class="px-2">
						<!-- <li class="list-disc list-inside py-1 text-gray-800 font-semibold"> <a href="/dhl/upload">  DHL FREIGHT UPLOAD</a> </li>  -->
						<!-- <li class="list-disc list-inside py-1  text-gray-800 font-semibold"> <a href="/users/role"> Rolle bearbieten</a> </li>  -->
						<li class="list-inside list-disc py-1 font-semibold text-gray-800">
							<a href="/orders/index"> Orders </a>
						</li>

						<li class="list-inside list-disc py-1 font-semibold text-gray-800">
							<a href="/orderitems/index">Order Item</a>
						</li>
						<li class="list-inside list-disc py-1 font-semibold text-gray-800">
							<a href="/orderitem/download">Orderitems Statistik</a>
						</li>
						<li class="list-inside list-disc py-1 font-semibold text-gray-800">
							<a href="/order/statistic"> Order Statistic</a>
						</li>
						<li class="list-inside list-disc py-1 font-semibold text-gray-800">
							<a href="/sparepart/statistic"> Spare part Statistic</a>
						</li>
					</ul>
				</div>
			</div>
			<!-- End of Service Bereich  -->

			<!-- Buchaltung Bereich     -->
			<div class="border border-gray-300 bg-slate-50 p-6">
				<div class="flex items-center">
					<svg
						fill="none"
						stroke="currentColor"
						stroke-linecap="round"
						stroke-linejoin="round"
						stroke-width="2"
						viewBox="0 0 24 24"
						class="h-8 w-8 text-gray-400"
					>
						<path
							d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
						></path>
					</svg>
					<div class="ml-4 text-lg font-semibold leading-7 text-gray-600">
						<a href="https://tailwindcss.com/"> Buchaltung </a>
					</div>
				</div>

				<div class="ml-12">
					<ul class="px 2">
						<li class="list-inside list-disc py-1 font-semibold text-gray-800">
							<a href="/orders/addison-export"> Addison Export </a>
						</li>
						<li class="list-inside list-disc py-1 font-semibold text-gray-800">
							<a href="/orders/index"> Orders </a>
						</li>
						<li class="list-inside list-disc py-1 font-semibold text-gray-800">
							<a href="/purchases/create"> Purchase Entry </a>
						</li>
						<li class="list-inside list-disc py-1 font-semibold text-gray-800">
							<a href="/purchases"> Purchase List</a>
						</li>

						<!-- <li class="list-disc list-inside py-1 text-gray-800 font-semibold"><a href="/manufacturers/index"> Manufacturers </a> </li> -->
						<!-- <li class="list-disc list-inside py-1 text-gray-800 font-semibold"><a href="/warehouses/index"> Warehosues </a> </li>                          -->
					</ul>
				</div>
			</div>
			<!-- end   -->
			<!-- Lager bereich  -->
			<div class="border border-gray-300 bg-slate-50 p-6 md:border-l">
				<div class="flex items-center">
					<svg
						fill="none"
						stroke="currentColor"
						stroke-linecap="round"
						stroke-linejoin="round"
						stroke-width="2"
						viewBox="0 0 24 24"
						class="h-8 w-8 text-gray-400"
					>
						<path
							d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
						></path>
					</svg>
					<div class="ml-4 text-lg font-semibold leading-7 text-gray-600">
						Lager Bereich
					</div>
				</div>

				<div class="m-2 flex flex-col">
					<h1 class="p-2 text-lg font-bold text-gray-900">Wichtig links</h1>
					<ul class="px-2">
						<li class="list-inside list-disc py-1 font-semibold text-gray-800">
							<a href="/dhl/upload"> DHL FREIGHT UPLOAD</a>
						</li>
						<!-- dsv  -->
						<li class="list-inside list-disc py-1 font-semibold text-gray-800">
							<a href="/dsv/index"> DSV Versand</a>
						</li>
						<!-- <li class="list-disc list-inside py-1  text-gray-800 font-semibold"> <a href="/users/role"> Rolle bearbieten</a> </li>  -->
					</ul>
				</div>
			</div>
			<!-- End of lager bereich  -->

			<div class="border-t border-gray-200 bg-slate-50 p-6 md:border-l">
				<div class="flex items-center">
					<svg
						fill="none"
						stroke="currentColor"
						stroke-linecap="round"
						stroke-linejoin="round"
						stroke-width="2"
						viewBox="0 0 24 24"
						class="h-8 w-8 text-gray-400"
					>
						<path
							d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
						></path>
					</svg>
					<div class="ml-4 text-lg font-semibold leading-7 text-gray-600">
						Admin Bereich
					</div>
				</div>

				<div class="m-2 flex flex-col">
					<h1 class="p-2 text-lg font-bold text-gray-900">Wichtig links</h1>
					<ul class="px-2">
						<li class="list-inside list-disc py-1 font-semibold text-gray-800">
							<a href="/register"> Register</a>
						</li>
						<li class="list-inside list-disc py-1 font-semibold text-gray-800">
							<a href="/users/role"> Rolle bearbieten</a>
						</li>
					</ul>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import JetApplicationLogo from "@/Jetstream/ApplicationLogo.vue";

export default {
	props: {
		user: {
			type: Object,
		},
		isFromService: {
			type: Boolean,
			default: true,
		},
	},
	components: {
		JetApplicationLogo,
	},
};
</script>
